import { AsesorChargeApi, DistrictApi } from "../../../../Shared/Constants/api";

import axiosInstance from "../../../../Shared/Utils/axiosInstance";

import { getDistrictCreationObject } from "../Data/DistrictWrappers";

export const updateDistrictApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${DistrictApi}/${id}`,
      getDistrictCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further District if needed
  }
};
